unit XData.Dataset.Utils;

interface

uses
  XData.Web.Dataset,
  WebLib.CDS,
  Data.DB;

type

  TXDataDSUtils = class
  public
    class procedure UpdateFieldValue(Dataset: TXDataWebDataset; Info: TResolveResults; const InfoIndex: Integer;
      const FieldName: string; const StayOnRecord: Boolean = True);

    class procedure UpdateAllIds(Dataset: TXDataWebDataset; Info: TResolveResults; const IdFieldName: string;
      const OnlyInserts: Boolean = True);

    class procedure UpdateAllFields(Dataset: TXDataWebDataset; Info: TResolveResults; const InfoIndex: Integer);

    class procedure UpdateAllRecords(Dataset: TXDataWebDataset; Info: TResolveResults);

  end;

implementation

uses
  JS;

{ TXDataDSUtils }

class procedure TXDataDSUtils.UpdateFieldValue(Dataset: TXDataWebDataset; Info: TResolveResults;
  const InfoIndex: Integer; const FieldName: string; const StayOnRecord: Boolean);
var
  BM: TBookmark;
begin
  BM := Dataset.GetBookmark;
  try
    Dataset.GotoBookmark(Info.Records[InfoIndex].BookMark);
    TJSObject(Dataset.CurrentData)[FieldName] := TJSObject(Info.Records[InfoIndex].Data)[FieldName];
  finally
    if not StayOnRecord then
      Dataset.GotoBookmark(BM);
    Dataset.FreeBookmark(BM);
  end;
end;

class procedure TXDataDSUtils.UpdateAllFields(Dataset: TXDataWebDataset; Info: TResolveResults;
  const InfoIndex: Integer);
var
  InfoObject, Data: TJSObject;
  I: Integer;
  lKey: string;
begin
  Dataset.GotoBookmark(Info.Records[InfoIndex].BookMark);
  Data := TJSObject(Dataset.CurrentData);
  InfoObject := TJSObject(Info.Records[InfoIndex].Data);

  for I := 0 to Length(TJSObject.keys(InfoObject)) - 1 do
  begin
    lKey := TJSObject.keys(InfoObject)[I];
    if Data.hasOwnProperty(lKey) then
      Data[lKey] := InfoObject[lKey];
  end;

end;

class procedure TXDataDSUtils.UpdateAllIds(Dataset: TXDataWebDataset; Info: TResolveResults; const IdFieldName: string;
  const OnlyInserts: Boolean = True);
var
  I: Integer;
  BM: TBookmark;
begin
  BM := Dataset.GetBookmark;
  try
    for I := 0 to Length(Info.Records) do
    begin
      if (not OnlyInserts) or (Info.Records[I].Status = TUpdateStatus.usInserted) then
      begin
        Dataset.GotoBookmark(Info.Records[I].BookMark);
        TJSObject(Dataset.CurrentData)[IdFieldName] := TJSObject(Info.Records[I].Data)[IdFieldName];
      end;
    end;
  finally
    Dataset.GotoBookmark(BM);
    Dataset.FreeBookmark(BM);
  end;
end;

class procedure TXDataDSUtils.UpdateAllRecords(Dataset: TXDataWebDataset; Info: TResolveResults);
var
  I: Integer;
  BM: TBookmark;
begin
  BM := Dataset.GetBookmark;
  try
    for I := 0 to Length(Info.Records) do
    begin
      UpdateAllFields(Dataset, Info, I);
    end;
  finally
    Dataset.GotoBookmark(BM);
    Dataset.FreeBookmark(BM);
  end;
end;

end.
